import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get } from 'lodash';

import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import Article from 'rebook/apps/base/components/Article';
import ArticleEmpty from 'rebook/apps/base/components/ArticleEmpty';
import BookPageHeader from 'rebook/apps/books/components/BookPageHeader';
import * as BookFragmentActions from 'rebook/apps/books/actions/BookFragmentActions';

import BookFragmentViewTrial from './BookFragmentViewTrial';

import styles from './style.scss';


const BookFragment = ({ fragment, pageNumber, lastPageNumber, handlePageChange, user, book }) => {
  const paginator = lastPageNumber > 1
    ? (
      <ContextPagination
        onPageChange={(newPageNumber) => handlePageChange(newPageNumber)}
        currentPage={pageNumber}
        lastPage={lastPageNumber} />
    )
    : null;

  return (
    <div className="backgroundContainer themeWhite">
      <div className={styles.bookFragment}>
        {paginator}
        {fragment === null
          ? <ArticleEmpty />
          : (
            <React.Fragment>
              <div className={styles.bookText}>
                <Article htmlContent={fragment} />
              </div>
              <BookFragmentViewTrial user={user} book={book} />
            </React.Fragment>
          )
        }
        {paginator}
      </div>
    </div>
  );
};

class BookFragmentView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    this.props.BookFragmentActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.BookFragmentActions.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(BookFragmentActions.fetchInitialData(match));
  }

  render() {
    const { book, fragment, pageNumber, lastPageNumber } = this.props.bookFragment;
    const { BookFragmentActions, user, payments } = this.props;

    return (
      <React.Fragment>
        <div className={styles.breadcrumbs}>
          <BreadCrumbs links={[
            { text: 'Библиотека', url: '/catalog/' },
            { text: get(book, 'main_author.cover_name', ''), url: get(book, 'main_author.absolute_url', '') },
            {
              text: `«${get(book, 'name', '')}»`,
              url: get(book, 'absolute_url', ''),
            },
            { text: 'Читать', url: '' },
          ]} />
        </div>
        <BookPageHeader book={book} hideControls pageType="fragment" />
        <BookFragment
          payments={payments}
          user={user}
          book={book}
          fragment={fragment}
          pageNumber={pageNumber}
          lastPageNumber={lastPageNumber}
          handlePageChange={(pageNumber) => BookFragmentActions.fetchFragmentPage(pageNumber)} />
      </React.Fragment>
    );
  }
}

BookFragmentView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      bookSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    bookFragment: state.bookFragment,
    user: state.user,
    payments: state.payments,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookFragmentActions: bindActionCreators(BookFragmentActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookFragmentView);
